/**
 * Coure.Hub.Service.Plan
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PlanSetupTbl { 
    id?: string;
    planInterval?: string;
    hourofDay?: string;
    minuteofHour?: string;
    dayofWeek?: string;
    servicePlanId?: string;
    serviceProviderId?: string;
    dateCreated?: Date;
    tenantId?: string;
}